export function areAllElementsFilled(arr: string[][]): boolean {
  if (!Array.isArray(arr) || !arr.every(row => Array.isArray(row))) {
    throw new Error('Input is not a 2D array');
  }

  return arr.every(row => row.every(element => element !== ''));
}
